import fetchAPI from '../../../../../lib/utils/fetch-api'

export const addFolder = async (data: { folder_name: string, folder_description?: string }) => {
  try {
    const response = await fetchAPI(`/api/file-folder/new`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
    if (response['errors']) {
      let error = response['errors']
      if (Array.isArray(error)) {
        error = error.join()
      }
      throw new Error(error)
    }

    return response
  } catch (err) {
    console.log(err)
    return false
  }
}
export const setFilesFolder = async (data: { folder_id: number; files_ids: number[] }) => {
  try {
    const response = await fetchAPI(`/api/file-folder/set`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
    if (response['errors']) {
      let error = response['errors']
      if (Array.isArray(error)) {
        error = error.join()
      }
      throw new Error(error)
    }

    return response
  } catch (err) {
    console.log(err)
    return false
  }
}
export const clearFilesFolder = async (data: { files_ids: number[] }) => {
  try {
    const response = await fetchAPI(`/api/file-folder/clear`, {
      method: 'POST',
      body: JSON.stringify(data),
    })
    if (response['errors']) {
      let error = response['errors']
      if (Array.isArray(error)) {
        error = error.join()
      }
      throw new Error(error)
    }

    return response
  } catch (err) {
    console.log(err)
    return false
  }
}
